var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('keep-alive',[_c('kontakt-detail',{attrs:{"woherKommstDu":"unternehmen"}})],1),_c('keep-alive',[_c('kontaktModal',{ref:"kontaktModalUnternehmen",attrs:{"woherKommstDu":"unternehmen"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }